import { ResponsiveTable } from './ResponsiveTable';

const ResponsiveTables = document.querySelectorAll('.table-wrapper');

ResponsiveTables.forEach((element) => {
    new ResponsiveTable(element);
});
